import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  ScheduleInterface,
  ScheduleOptions,
} from '@fc-core/models/operator-schedule.model';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleScheduleService {
  constructor(private http: HttpClient) {}

  getVehicleSchedule(options: ScheduleOptions) {
    let params = new HttpParams();
    params = params.append('duration__range_lower', options.lower);
    params = params.append('duration__range_upper', options.upper);
    return this.http
      .get(`${environment.apiUrl}api/vehicles/${options.currentId}/schedule/`, {
        params,
      })
      .pipe(map((res: any) => res.results));
  }

  addVehicleSchedule(schedule: ScheduleInterface) {
    return this.http.post(
      `${environment.apiUrl}api/vehicles/${schedule.vehicle}/schedule/`,
      schedule,
    );
  }

  deleteVehicleSchedule(schedule: ScheduleInterface) {
    return this.http.delete(
      `${environment.apiUrl}api/vehicles/${schedule.vehicle}/schedule/${schedule.id}/`,
    );
  }

  updateVehicleSchedule(
    schedule: ScheduleInterface,
  ): Observable<ScheduleInterface> {
    return this.http.put(
      `${environment.apiUrl}api/vehicles/${schedule.vehicle}/schedule/${schedule.id}/`,
      schedule,
    );
  }
}
